import {PartyType, TransferType} from '@sollapay/enums';
import {Money} from '@sollapay/utils';

import type {PayoutTransferType} from '@sollapay/enums';

/** At or above this amount a transfer must clear via zahav (RTGS) — masav is not allowed. */
export const ZAHAV_ONLY_THRESHOLD_NIS = '1000000';

/** A blank amount is never zahav-only, so forms can call this before an amount is entered. */
export function isZahavOnlyAmount(amount: string): boolean {
  return !!amount && Money.from(amount).gte(ZAHAV_ONLY_THRESHOLD_NIS);
}

/** Masav is capped below the zahav-only threshold; zahav is allowed at any amount. */
export function isTransferTypeAllowedForAmount(params: {
  amount: string;
  transferType: PayoutTransferType | null;
}): boolean {
  return !(params.transferType === TransferType.MASAV && isZahavOnlyAmount(params.amount));
}

/** PIS is for private buyers only — an organization buyer pays by self-transfer. */
export function isPisAllowedForPartyType(partyType: PartyType | undefined): boolean {
  return partyType !== PartyType.ORGANIZATION;
}
